import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

export function download(value) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "untitled";
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "Save";
  var a = document.createElement("a");
  var b = a.appendChild(document.createElement("button"));
  b.textContent = label;
  a.download = name;

  function reset() {
    return _reset.apply(this, arguments);
  }

  function _reset() {
    _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return new Promise(requestAnimationFrame);

            case 2:
              URL.revokeObjectURL(a.href);
              a.removeAttribute("href");
              b.textContent = label;
              b.disabled = false;

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _reset.apply(this, arguments);
  }

  a.onclick = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
      var object;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              b.disabled = true;

              if (!a.href) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", reset());

            case 3:
              // Already saved.
              b.textContent = "Saving…";
              _context.prev = 4;
              _context.next = 7;
              return typeof value === "function" ? value() : value;

            case 7:
              object = _context.sent;
              b.textContent = "Download";
              a.href = URL.createObjectURL(object); // eslint-disable-line require-atomic-updates

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              b.textContent = label;

            case 15:
              if (!event.eventPhase) {
                _context.next = 17;
                break;
              }

              return _context.abrupt("return", reset());

            case 17:
              // Already downloaded.
              b.disabled = false;

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return a;
}